import axios from './axios';

import auth from '../resources/Auth';

const API_URL = process.env.REACT_APP_API_URL;

const headers = () => ({ Authorization: `Bearer ${auth.token}` });

export default {
  types: async () => {
    return await axios.get(`${API_URL}/vaccine/types`, { headers: headers() });
  },

  myWaitlist: async () => {
    return await axios.get(`${API_URL}/vaccine/waitlist`, { headers: headers() });
  },

  enroll: async (payload) => {
    return await axios.post(`${API_URL}/vaccine/waitlist`, payload, { headers: headers() });
  },

  removeEntry: async (id) => {
    return await axios.delete(`${API_URL}/vaccine/waitlist/${id}`, { headers: headers() });
  },

  proposals: async () => {
    return await axios.get(`${API_URL}/vaccine/proposals`, { headers: headers() });
  },

  respond: async (id, response) => {
    return await axios.post(`${API_URL}/vaccine/proposals/${id}/respond`, { response }, { headers: headers() });
  },

  appointments: async () => {
    return await axios.get(`${API_URL}/vaccine/appointments`, { headers: headers() });
  },

  cancelAppointment: async (id) => {
    return await axios.delete(`${API_URL}/vaccine/appointments/${id}/cancel`, { headers: headers() });
  },
};
